
export default "/assets/gift-mini.5fd6c398.svg"